import {Navigate, Outlet} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {shallowEqual} from 'react-redux'
import {RootState} from '../../setup'

const ProtectedRoute = () => {
  const isAuthenticated = useSelector<RootState>(({auth}) => auth.access_token, shallowEqual)

  return isAuthenticated ? <Outlet /> : <Navigate to='/login' replace />
}

export default ProtectedRoute
